/**
 * The note's CodeMirror editor (`@codemirror/*`) is imported only through this dynamic `import()`,
 * like the Markdown renderer (`loadNoteMarkdown.ts`): the bundler emits a separate chunk that the
 * first screen never loads. Until it arrives, or when loading fails, the note is edited in a plain
 * text box. A static value import of `./NoteEditor` anywhere in first-screen code would pull the
 * chunk back in.
 */
export type NoteEditorModule = typeof import('./NoteEditor');

let pending: Promise<NoteEditorModule> | null = null;
let loaded: NoteEditorModule | null = null;

/** The module if it was loaded already (a card mounted later edits in it at once). */
export const loadedNoteEditor = (): NoteEditorModule | null => loaded;

/** Load the module once; a failed load is forgotten so that the next call tries again. */
export function loadNoteEditor(): Promise<NoteEditorModule> {
  pending ??= import('./NoteEditor').then(
    (module) => {
      loaded = module;
      return module;
    },
    (error: unknown) => {
      pending = null;
      throw error;
    },
  );
  return pending;
}
